<template>
  <el-date-picker
    v-if="!item.live_load"
    v-model.lazy="item.notified_at"
    size="mini"
    type="datetime"
    :format="dateTimeFormat"
    :value-format="'yyyy-MM-dd HH:mm'"
    @change="$emit('columnEvent', 'autoSave', item, 'notified_at', $event)"
  />
</template>

<script>
import { dateTimeComputed } from "@/default/utils/computed";

export default {
  name: "order-status-notified-at",
  computed: {
    ...dateTimeComputed,
  },
  props: {
    item: Object,
    options: Object,
  },
};
</script>
